import { Check } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";

export default function ShowLevelPop({ level, dataLevel, height }) {
  const data = [
    { number: 1, blueText: "اطلاعات کلی", grayText: "انتخاب نام و زمان اردو" },
    {
      number: 2,
      blueText: "تعریف منطقه",
      grayText: "انتخاب مسئول و منطقه اردو",
    },
  ];
  return (
    <Box display={"flex"} alignItems="center">
      <Box
        width="2px"
        borderRadius={"40px"}
        height={height || "170px"}
        bgcolor="#B2D8E0"
      ></Box>
      {!dataLevel && (
        <Box mr="-14px">
          {data.map((x, i) => (
            <>
              <Box display="flex" gap="15px" alignItems={"center"}>
                <Box
                  border={`solid 1px ${
                    level === x.number
                      ? "white"
                      : level > x.number
                      ? "#00CA72"
                      : "var(--emr-darkblue)"
                  } `}
                  borderRadius="50%"
                  bgcolor={level === x.number ? "var(--emr-darkblue)" : "white"}
                  width="25px"
                  height="25px"
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent="center"
                  color={level === x.number ? "white" : "var(--emr-darkblue)"}
                >
                  {level > x.number && (
                    <Check sx={{ transform: "scale(0.8)", color: "#00CA72" }} />
                  )}
                  {level > x.number ? "" : x.number}
                </Box>
                <Box>
                  <Typography color="var(--emr-darkblue)" fontWeight="bold">
                    {x.blueText}
                  </Typography>
                  <Typography
                    color="var(--emr-gray)"
                    fontSize="12px"
                  >{`(${x.grayText})`}</Typography>
                </Box>
              </Box>
              {i === 0 && (
                <Box
                  my="20px"
                  mr="7px"
                  bgcolor="#B2D8E0"
                  width="13px"
                  height="13px"
                  borderRadius="50%"
                ></Box>
              )}
            </>
          ))}
        </Box>
      )}

      {dataLevel && (
        <Box
          mr="-14px"
          sx={{
            overflow: "scroll",
            height: "73vh",
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box sx={{ overflow: "scroll" }}>
            {dataLevel.map((x, i) => (
              <>
                <Box display="flex" gap="15px" alignItems={"center"}>
                  <Box
                    border={`solid 1px ${
                      level === x.number
                        ? "white"
                        : level > x.number
                        ? "#00CA72"
                        : "var(--emr-darkblue)"
                    } `}
                    borderRadius="50%"
                    bgcolor={
                      level === x.number ? "var(--emr-darkblue)" : "white"
                    }
                    width="25px"
                    height="25px"
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent="center"
                    color={level === x.number ? "white" : "var(--emr-darkblue)"}
                  >
                    {level > x.number && (
                      <Check
                        sx={{ transform: "scale(0.8)", color: "#00CA72" }}
                      />
                    )}
                    {level > x.number ? "" : x.number}
                  </Box>
                  <Box>
                    <Typography color="var(--emr-darkblue)" fontWeight="bold">
                      {x.blueText}
                    </Typography>
                    <Typography
                      color="var(--emr-gray)"
                      fontSize="12px"
                    >{`(${x.grayText})`}</Typography>
                  </Box>
                </Box>
                {i !== dataLevel.length - 1 && (
                  <Box
                    my="20px"
                    mr="7px"
                    bgcolor="#B2D8E0"
                    width="13px"
                    height="13px"
                    borderRadius="50%"
                  ></Box>
                )}
              </>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
